import * as R from 'ramda';
import { Role, RoleType } from '../../../../../orders/actions/types/actions.types';
import { OfflineOrderProduct } from '../../orderProduct/OfflineOrderProduct';
import { OrderProductWithError } from '../OfflineOrderRules.types';
import BaseOrderProductRule from './baseOrderProduct.rule';

export default abstract class BaseOrderProductQuantityRule extends BaseOrderProductRule {
  protected canUserBypassRule(userRole: RoleType): boolean {
    return userRole === Role.ADMIN_MARCA;
  }

  protected groupOrderProductsByProductId(
    orderProducts: OfflineOrderProduct[],
  ): Record<string, OfflineOrderProduct[]> {
    return R.groupBy((orderProduct) => orderProduct.product.id, orderProducts) as Record<
      string,
      OfflineOrderProduct[]
    >;
  }

  protected getOrderProductsTotalQuantity(orderProducts: OfflineOrderProduct[]): number {
    return orderProducts.reduce(
      (acc, orderProduct) => acc + orderProduct.getTotalGridQuantity(),
      0,
    );
  }

  protected validateMultipleOf(quantity: number, multipleOf: number): boolean {
    if (multipleOf <= 0) {
      return false;
    }
    return quantity % multipleOf === 0;
  }

  protected pushAllProductsWithError(
    orderProducts: OfflineOrderProduct[],
    extra: OrderProductWithError['extra'],
  ) {
    orderProducts.forEach((orderProduct) => {
      this.pushOrderProductWithError(orderProduct, extra);
    });
  }
}
